export const CHANNEL_CHANGE_RECEIVED = 'CHANNEL_CHANGE_RECEIVED';
export const GENERIC_CHANNEL_CHANGE_RECEIVED = 'GENERIC_CHANNEL_CHANGE_RECEIVED';